// export const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
export const API_URL = 'https://erp.api.tecnospice.com';


// Auth
export const LOGIN = '/api/auth/login/';
export const LOGOUT = '/api/auth/logout/';
export const USER_PROFILE = '/api/auth/me/';
export const USERS = '/api/auth/users/';
export const ROLES = '/api/auth/roles/';

// Finance
export const BUDGETS = '/api/finance/budgets/';
export const BUDGET_OVERVIEW = '/api/finance/budgets/overview/';
export const BUDGET_SUMMARY = '/api/finance/budgets/overview/'; // legacy alias
export const INVOICES = '/api/finance/invoices/';
export const OUTSTANDING_INVOICES = '/api/finance/invoices/outstanding/';
export const CASH_ENTRIES = '/api/finance/cash-entries/';
export const CASH_ENTRY_DETAIL = (id) => `/api/finance/cash-entries/${id}/`;
export const CASH_COLLECTED_SUMMARY = '/api/finance/cash-collected/';
export const RUNWAY = '/api/finance/runway/';
export const TARGETS = '/api/finance/targets/';
export const TARGETS_VS_ACTUAL = '/api/finance/targets/vs-actual/';

// Dashboard
export const DASHBOARD_OVERVIEW = '/api/dashboard/overview/';
export const HEALTH_SCORE = '/api/dashboard/health-score/';
export const CROSS_SIGNALS = '/api/dashboard/cross-signals/';
export const RECEIVABLES_SUMMARY = '/api/dashboard/receivables-summary/';
export const TRENDS = '/api/dashboard/trends/';
export const SNAPSHOTS = '/api/dashboard/snapshots/';

// Integrations
export const HRMS_DATA = '/api/integrations/hrms/';
export const CRM_DATA = '/api/integrations/crm/';
export const CRM_RECEIVABLES = '/api/integrations/crm/receivables/';
export const CRM_SALES_LEADERBOARD = '/api/integrations/crm/sales-leaderboard/';
export const CRM_SALES_EXTRAS = '/api/integrations/crm/sales-extras/';
export const TICKETING_DATA = '/api/integrations/ticketing/';
export const PROJECTS_DATA = '/api/integrations/projects/';
export const INTEGRATION_STATUS = '/api/integrations/status/';

// CRM Connection
export const CRM_CONNECT = '/api/integrations/crm/connect/';
export const CRM_CONNECTION = '/api/integrations/crm/connection/';
export const CRM_TEST = '/api/integrations/crm/test/';
export const CRM_DISCONNECT = '/api/integrations/crm/disconnect/';

// HRMS Connection
export const HRMS_CONNECT = '/api/integrations/hrms/connect/';
export const HRMS_CONNECTION = '/api/integrations/hrms/connection/';
export const HRMS_TEST = '/api/integrations/hrms/test/';
export const HRMS_DISCONNECT = '/api/integrations/hrms/disconnect/';

// Ticketing (FixDesk) Connection
export const TICKETING_CONNECT = '/api/integrations/ticketing/connect/';
export const TICKETING_CONNECTION = '/api/integrations/ticketing/connection/';
export const TICKETING_TEST = '/api/integrations/ticketing/test/';
export const TICKETING_DISCONNECT = '/api/integrations/ticketing/disconnect/';

// People (Employee Mapping)
export const PEOPLE = '/api/people/';
export const PEOPLE_AVAILABLE = '/api/people/available/';

// Assignments
export const ASSIGNMENTS_TASKS = '/api/assignments/tasks/';
export const ASSIGNMENTS_SUMMARY = '/api/assignments/summary/';

// Alerts
export const ACTIVE_ALERTS = '/api/alerts/active/';
export const ALERT_HISTORY = '/api/alerts/history/';
